export const CLEAR_MESSAGES = 'ui/CLEAR_MESSAGES'
export const SHOW_INFO_MESSAGE = 'ui/SHOW_INFO_MESSAGE'
